<template>
  <!-- Spinner affiché pendant le chargement -->
  <div class="full-content loading-dots">
    <span v-if="loadingText" v-html="loadingText"></span>
    <span v-if="!loadingText">{{ $t("loading-in-progress") }}</span>
    <span class="dot" v-html="point" /><span class="dot" v-html="point" /><span
      class="dot"
      v-html="point"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "LoadingFullScreenSpinner",
  props: {
    loadingText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      point: ".",
    }
  },
})
</script>

<style lang="scss">
.full-content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.loading-dots {
  font-size: 18px;
}

.dot {
  opacity: 0;
  animation: blink 1.5s infinite step-start;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.5s;
}

.dot:nth-child(3) {
  animation-delay: 1s;
}

@keyframes blink {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>
